import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { ToastService } from '@portal-front/design-system';
import { UnknownServerOrConnectionError } from './unknown-server-or-connectrion-error.model';
import { catchError, Observable } from 'rxjs';

@Injectable()
export class ServerErrorInterceptor implements HttpInterceptor {
  readonly toastService = inject(ToastService);

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      catchError((error) => {
        if (error instanceof HttpErrorResponse && (!error.status || error.status >= 500)) {
          this.toastService.showGenericError();
          throw new UnknownServerOrConnectionError();
        }
        throw error;
      }),
    );
  }
}
